import { render, staticRenderFns } from "./ExerciseChart.vue?vue&type=template&id=54a6bd6d&scoped=true&"
import script from "./ExerciseChart.vue?vue&type=script&lang=js&"
export * from "./ExerciseChart.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseChart.vue?vue&type=style&index=0&id=54a6bd6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a6bd6d",
  null
  
)

export default component.exports